import AuthorInfo from '@rsa-digital/evo-shared-components/components/AuthorInfo';
import { graphql } from 'gatsby';
import React from 'react';
import { processImageAsset } from 'helpers/csTypeProcessors';
import { CsAsset } from 'types/contentStack';

type AuthorInfoBlockProps = {
  author_info: {
    author: string;
    body: string;
    image: CsAsset;
  };
};

export const query = graphql`
  fragment AuthorInfoBlock on cs__author_info {
    author
    body
    image {
      ...Asset
    }
  }
`;

const AuthorInfoBlock: React.FC<AuthorInfoBlockProps> = ({ author_info }) => {
  const { author, body, image } = author_info;
  const processedImage = processImageAsset(image);

  /* istanbul ignore if */
  if (!processedImage) {
    throw new Error('Image missing for author info block!');
  }

  return (
    <AuthorInfo
      author={author}
      body={body}
      image={processedImage}
      showAuthorPrefix={false}
      data-cy="AuthorInfo"
    />
  );
};

export default React.memo(AuthorInfoBlock);
